<template>
  <div class="main" ref="activity_scroll" @scroll="activityScroll">
    <ul class="p-o-video">
        <li v-for="item in proList" :key="item.id" @click="gotoDetail(item.id)">
            <img class="img" :src="cdnUrl + item.cover_img" alt="">
            <p class="one">{{ item.title }}</p>
        </li>
    </ul>

    <footerLine></footerLine>
  </div>
</template>

<script>
import { getProductList } from '@/api/product'
import footerLine from '@/components/footerLine'
export default {
    components: {
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            proList: []
        }
    },
    created() {
        this.getProList()
    },
    methods: {
        getProList() {
            let para = {
                page: this.page,
                type: '5'
            }
            getProductList(para).then(res => {
                this.proList.push(...res.data.data)
                this.last_page = res.data.last_page
            })
        },
        gotoDetail(id) {
            this.$router.push({
                name: 'pipOperDetail',
                query:{
                    id
                }
            })
        },
        activityScroll () {
            console.log('看看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.main {
    height: 100vh;
    overflow: auto;
}
.p-o-video {
    display: flex;
    flex-direction: column;
    align-items: center;
    li {
        position: relative;
        width: rem(343);
        height: rem(179);
        margin-top: rem(16);
        border-radius: rem(6);
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        img {
            width: 100%;
            height: rem(179);
            border-radius: rem(6);
        }
        p {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: rem(24);
            line-height: rem(24);
            text-align: center;
            color: #fff;
            background: rgba(124, 201, 218, 0.9);
            border-radius: 0 0 rem(6) rem(6);
        }
    }
}
</style>